import { render, staticRenderFns } from "./RegisterKey.vue?vue&type=template&id=4cb60c66"
import script from "./RegisterKey.vue?vue&type=script&lang=js"
export * from "./RegisterKey.vue?vue&type=script&lang=js"
import style0 from "./RegisterKey.vue?vue&type=style&index=0&id=4cb60c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports